// extracted by mini-css-extract-plugin
export var label = "_a5-1";
export var reminder = "_a5-0";